import * as Brand from '@brand';

export default function BrandLogo({size = 64, style = {}}) {
    const src = Brand.symbolUrl || Brand.logoUrl;
    if (!src) return null;
    return (
        <img
            src={src}
            alt={Brand.brand.name || 'Brand'}
            style={{
                width: size, height: size,
                borderRadius: size * 0.28,
                objectFit: 'contain',
                display: 'block',
                ...style
            }}
        />
    )
}